module.exports = __webpack_public_path__ + "assets/images/project/head/Pasha_Cas.jpg?v=53a09668";